export type LocationStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;
interface ILocationStatusEnum {
    Default: LocationStatus;
    Waiting: LocationStatus;
    Open: LocationStatus;
    Busy: LocationStatus;
    Closed: LocationStatus;
    Free: LocationStatus;
    Occupied: LocationStatus;
    getName(): string;
    format(value: number): string | undefined;
    doesContainValue(value: string): boolean;
}

const datasource = () => [
    { id: 0, name: 'Būsena neaktyvi', code: null, type: null, group: null },
    { id: 1, name: 'Prašome užeiti', code: null, type: null, group: null },
    { id: 2, name: 'Darbas su dokumentais', code: null, type: null, group: null },
    { id: 3, name: 'Pertrauka', code: null, type: null, group: null },
    { id: 4, name: 'Nedirba', code: null, type: null, group: null },
    { id: 5, name: 'Laisva', code: null, type: null, group: null },
    { id: 6, name: 'Užimta', code: null, type: null, group: null }
];

export const locationStatus: ILocationStatusEnum = {
    Default: 0,
    Waiting: 1,
    Open: 2,
    Busy: 3,
    Closed: 4,
    Free: 5,
    Occupied: 6,
    getName() {
        return 'Location Status';
    },
    format(value: number) {
        const item = datasource().find(x => x.id === value);
        return item && item.name;
    },
    doesContainValue(value: string) {
        var resp = false;
        datasource().map(x => {
            if (x.name === value) {
                resp = true;
            }
        });
        return resp;
    }
};
